import { useGamificationSettings } from "@circle-react/components/SettingsApp/Gamification/LevelsForm/gamificationApi";
import type { RenderFilter } from "./types";

export const useShouldShowLevelFilter = (
  filters: RenderFilter[],
): RenderFilter[] => {
  const { data: gamificationSettings } = useGamificationSettings();

  if (gamificationSettings?.enabled) {
    return filters;
  }

  return filters.filter(filter => filter.name !== "level");
};
